import React, { useRef } from 'react';
import { FixedSizeGrid as Grid } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

const VirtualList = ({ columnCount, rowCount, itemData, columnWidth, rowHeight, onRowsRendered }) => {
  const gridRef = useRef();

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const item = itemData[rowIndex * columnCount + columnIndex];
    return (
      <div style={style} className="grid-item">
        {item}
      </div>
    );
  };

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Grid
          ref={gridRef}
          columnCount={columnCount}
          columnWidth={columnWidth}
          height={height}
          rowCount={rowCount}
          rowHeight={rowHeight}
          width={width}
          itemData={itemData}
          onItemsRendered={({ visibleRowStopIndex }) => {
            if (typeof onRowsRendered === 'function') {
              onRowsRendered(visibleRowStopIndex);
            }
          }}
        >
          {Cell}
        </Grid>
      )}
    </AutoSizer>
  );
};

export default VirtualList;
